import React, { createContext, useContext } from 'react'

export default (mapPropertiesToValue) => {
  const Context = createContext({})

  const Provider = (properties) => (
    <Context.Provider value={mapPropertiesToValue(properties)}>
      {properties.children}
    </Context.Provider>
  )

  return {
    Provider,
    useContext: () => useContext(Context),
  }
}
